import type { CSSProperties } from 'react';
import React from 'react';

import { Tooltip } from 'antd';

interface IProps {
  count: number;
  final?: string;
  style?: CSSProperties;
  title?: string;
  after?: React.ReactNode;
  children?: React.ReactNode;
}

const Truncate = ({ count, final = '...', style, title, children, after }: IProps) => {
  const cropText = (value: string) => {
    value = value.slice(0, Number(count));
    return `${value.trim()}${final}`;
  };

  const isString = typeof children === 'string';
  const shouldCrop = isString && children.length > count;

  return (
    <div style={style} title={title}>
      {shouldCrop ? (
        <Tooltip title={children} placement='top'>
          <span>{cropText(children)}</span>
        </Tooltip>
      ) : (
        children
      )}
      {after}
    </div>
  );
};

export default Truncate;
